<template lang="pug">
  div.item(v-if="item.code !== undefined",:style="pos(pnum,num)")
    figure
      img(:src="'./static/front/' + item.code + '.svg'",:style="imgSty(pnum,num)")
      div.code(v-if="preview === true") {{item.code}}
    div.del(v-if="delflg") 削除
    div.cross(v-if="fg")
</template>

<script>
import store from '../../stores/index';
export default {
  name: 'Item',
  data () {
    return {
      fg: false,
      chk: -1,
      mouseflg: false,
      itemflg: false,
      delflg: false,
      item: {},
      $info: {},
      parent: 0,
      child: 0,
      height: 0,
      space: 0,
      hole: 0,
      prev: 0,
      previtem: '',
      $tar: {},
      dragged: {},
      elem: {},
      slits: []
    };
  },
  props: {
    pnum: Number,
    num: Number,
    dat: Object
  },
  computed: {
    infoitem () {
      return this.$store.getters.infoitem;
    }
  },
  watch: {
    number () {
      this.update();
      this.slits[this.pnum].floor.splice(this.num, 1, this.item);
    },
    sets () {
      this.update();
      this.slits[this.pnum].floor.splice(this.num, 1, this.item);
    }
  },
  methods: {
    update () {
      let me = this;
      if (me.sets[me.number] !== undefined) {
        me.set = me.sets[me.number];
        me.slits = me.set.slits;
        me.height = me.c2p(me.set.size[1]);
        if (me.slits !== undefined) {
          if (me.prev !== me.chk && me.slits[me.chk] !== undefined) {
            me.space = me.slits[me.chk + 1].pos - me.slits[me.chk].pos;
          } else {
            me.space = me.slits[me.pnum + 1].pos - me.slits[me.pnum].pos;
          }
          if (me.slits[me.pnum].floor[me.num] !== undefined) {
            me.itemflg = false;
            let itm = me.slits[me.pnum].floor[me.num];
            if (itm.dat !== undefined) {
              me.items = itm.dat.item;
              me.item.display = false;
              for (let prop in me.items) {
                if (me.space === Number(me.items[prop].w)) {
                  me.item = me.acopy(me.items[prop]);
                  me.item.dat = itm.dat;
                  me.item.y = itm.y;
                  me.itemflg = true;
                  me.item.display = true;
                }
              }
            }
          }
          me.hole = Number(me.slits[0].slit.hole);
          // 壁掛けとの重なり
          let inps = document.querySelectorAll('.items-area .slit:nth-child(' + (me.pnum + 1) + ') .items .item');
          let btm = 0;
          for (const inp of inps) {
            if (btm < inp.getBoundingClientRect().bottom) {
              btm = inp.getBoundingClientRect().bottom;
            }
          }
          if (me.elem.getBoundingClientRect && me.item.display) {
            if (btm > me.elem.getBoundingClientRect().top) {
              me.item.display = false;
            } else {
              me.item.display = true;
            }
          }
        }
      }
    },
    pos (i, s) {
      let itm = this.slits[i].floor[s];
      return {
        left: '0px',
        width: this.c2p(itm.w) + 'px',
        height: this.c2p(itm.h) + 'px'
      };
    },
    imgSty (i, s) {
      let opacity;
      let itm = this.slits[i].floor[s];
      if (itm.display) {
        opacity = 1;
      } else {
        opacity = 0.3;
      }
      return {
        opacity: opacity
      };
    },
    open (e) {
      let dat = {
        left: this.mp(e).clientX,
        top: this.mp(e).clientY,
        display: true,
        item: this.item
      };
      store.commit('setInfoitem', dat);
      window.addEventListener('mouseout', this.mouseout, false);
      window.addEventListener('touchcancel', this.mouseout, false);
    },
    mouseout () {
      let dat = {
        display: false
      };
      store.commit('setInfoitem', dat);
      window.removeEventListener('mouseup', this.mouseup, false);
      window.removeEventListener('mousemove', this.mousemove, false);
      window.removeEventListener('mouseout', this.mouseout, false);
      window.removeEventListener('touchmove', this.mousemove, false);
      window.removeEventListener('touchcancel', this.mouseout, false);
      window.removeEventListener('touchend', this.mouseup, false);
    },
    mousedown (e) {
      this.prev = this.pnum;
      this.$tar = e.currentTarget;
      this.sX = parseInt(this.$tar.style.left) || 0;
      this.sY = parseInt(this.$tar.style.top) || 0;
      this.startX = this.mp(e).clientX;
      this.startY = this.mp(e).clientY;
      this.flg = true;
      const targetElements = e.target.parentNode.children;
      this.child = Array.from(targetElements).indexOf(e.target);
      const childElements = e.target.parentNode.parentNode.children;
      this.parent = Array.from(childElements).indexOf(e.target.parentNode);
      let ah = (this.height / this.hole);
      this.startPosY = Math.round((this.mp(e).clientY - this.startY + this.sY) / ah);
      window.addEventListener('mousemove', this.mousemove, false);
      window.addEventListener('mouseup', this.mouseup, false);
      window.addEventListener('touchmove', this.mousemove, false);
      window.addEventListener('touchend', this.mouseup, false);
    },
    mousemove (e) {
      let me = this;
      if (me.flg) {
        me.$tar.classList.add('dragging');
        let ah = (me.height / me.hole);
        me.posY = Math.round((me.mp(e).clientY - me.startY + me.sY) / ah);
        me.chk = me.mouseSlit(e); // ドラック要素がどのスリット内か調べる
        if (me.chk === -1) {
          // 削除エリアのとき
          me.delflg = true;
          me.posX = me.mp(e).clientX - me.startX + me.sX;
          me.$tar.style.left = me.posX + 'px';
          if (me.item.under) {
            me.$tar.style.top = '';
          }
        } else {
          // スリットエリア内のとき
          me.delflg = false;
          me.$tar.style.left = '0px';
          if (me.item.under) {
            me.$tar.style.top = '';
          }
          if (me.posY < 0) {
            me.posY = 0;
          } else if (me.hole < me.posY + me.item.hole) {
            me.posY = me.hole - me.item.hole;
          }
        }

        if (me.prev !== me.chk && me.chk !== -1) {
          // ドラッグで別のスリットに移動したとき
          let parent = document.querySelector('.items-area .slit:nth-child(' + (me.chk + 1) + ') .flr');
          parent.appendChild(me.$tar);
          me.sX = parseInt(me.$tar.style.left) || 0;
          me.startX = me.mp(e).clientX;
          me.update();
        }
        // 他商品と重なりチェック
        me.fg = false;
        if (me.slits[me.prev] !== undefined) {
          if (me.slits[me.prev].floor !== undefined) {
            if (me.prev !== me.pnum) {
              if (me.slits[me.prev].floor.length > 0) {
                me.fg = true;
                if (me.delflg) {
                  me.fg = false;
                }
              }
            }
          }
        }
        let elements = document.querySelectorAll('.items-area .slit:nth-child(' + (me.chk + 1) + ') .items .item');
        if (elements) {
          let btm = 0;
          elements.forEach(function (userItem, i) {
            if (btm < userItem.getBoundingClientRect().bottom) {
              btm = userItem.getBoundingClientRect().bottom;
            }
          });
          if (btm >= me.$tar.getBoundingClientRect().top) {
            me.fg = true;
          }
        }
        if (!me.itemflg) {
          me.fg = true;
          if (me.delflg) {
            me.fg = false;
          }
        }
        me.item.y = me.posY;
        if (me.previtem !== JSON.stringify(me.item)) {
          me.slits[me.pnum].floor.splice(me.num, 1, me.item);
        }

        // 一つ前を保持
        if (me.chk === -1) {
          me.prev = me.num;
        } else {
          me.prev = me.chk;
        }
      }
      me.mouseflg = true;

      me.previtem = JSON.stringify(me.item);
    },
    mouseup (e) {
      if (!this.infoitem.display && !this.mouseflg) {
        this.open(e);
      } else {
        this.mouseout();
      }
      if (this.mouseflg) {
        this.mouseflg = false;
      }
      this.$tar.classList.remove('dragging');
      this.parent = 0;
      this.child = 0;
      if (this.fg) {
        this.itemBack();
      } else if (this.delflg) {
        this.prev = this.pnum;
        this.itemDelete();
      } else if (this.prev !== this.pnum) {
        this.itemMove();
      }
      this.flg = false;
      this.fg = false;
      window.removeEventListener('mousemove', this.mousemove);
      window.removeEventListener('mouseup', this.mouseup);
      window.removeEventListener('touchmove', this.mousemove);
      window.removeEventListener('touchend', this.mouseup);
    },
    itemMove () {
      let parent = document.querySelector('.items-area .slit:nth-child(' + (this.pnum + 1) + ') .flr');
      parent.appendChild(this.$tar);
      if (this.slits[this.prev].floor !== undefined) {
        this.slits[this.prev].floor.push(this.item);
        this.slits[this.pnum].floor.splice(this.num, 1);
        this.sets.splice(this.number, 1, this.set);
      }
    },
    itemBack () {
      this.item.y = this.startPosY;
      let parent = document.querySelector('.items-area .slit:nth-child(' + (this.pnum + 1) + ') .flr');
      parent.appendChild(this.$tar);
      this.slits[this.pnum].floor.splice(this.num, 1, this.item);
      this.sets.splice(this.number, 1, this.set);
    },
    itemDelete () {
      let parent = document.querySelector('.items-area .slit:nth-child(' + (this.pnum + 1) + ') .flr');
      parent.appendChild(this.$tar);
      this.$tar.style.left = '0px';
      this.slits[this.pnum].floor.splice(0, 1);
      this.sets.splice(this.number, 1, this.set);
      this.delflg = false;
    }
  },
  created () {
    this.update();
  },
  destroyed () {
    this.$el.removeEventListener('mousedown', this.mousedown);
    this.$el.removeEventListener('touchstart', this.mousedown);
  },
  mounted () {
    if ('ontouchstart' in window) {
      this.$el.addEventListener('touchstart', this.mousedown);
    } else {
      this.$el.addEventListener('mousedown', this.mousedown);
    }
    this.elem = this.$el;
  }
};
</script>

<style lang="stylus" scoped>
  .item
    width 100%
    position absolute
    left 0
    bottom 0
    cursor pointer
    user-select none
    filter drop-shadow(1px 1px 3px rgba(0,0,0,0.2))
    &.dragging
      z-index 1000
    figure
      line-height 1
      img
        width 100%
        pointer-events none
      .code
        position absolute
        left 0
        top 25px
        width 100%
        text-align center
        font-size 14px
        text-shadow 1px 1px 1px #ffffff,-1px -1px 1px #ffffff,-1px 1px 1px #ffffff,1px -1px 1px #ffffff,1px 0px 1px #ffffff,-1px 0px 1px #ffffff,0px 1px 1px #ffffff,0 -1px 1px #ffffff
  .cross
    display flex
    justify-content center
    align-items center
    width 20px
    height 20px
    background-color #cc0000
    color #ffffff
    line-height 1
    border-radius 50%
    position absolute
    left 50%
    top 0
    transform translate(-50%, 0)
    &:before
      content ""
      display block
      width 10px
      height 2px
      background-color #ffffff
      position absolute
      left 50%
      top 50%
      transform translate(-50%,-50%) rotate(45deg)
    &:after
      content ""
      display block
      width 10px
      height 2px
      background-color #ffffff
      position absolute
      left 50%
      top 50%
      transform translate(-50%,-50%) rotate(-45deg)
  .del
    position absolute
    left 50%
    transform translate(-50%,0)
    padding 5px 10px
    font-size 12px
    top -40px
    color #ffffff
    white-space nowrap
    border-radius 3px
    background-color #000000cc
</style>



// WEBPACK FOOTER //
// src/components/front/FItem.vue